import { useState } from 'react'
import dynamic from 'next/dynamic'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { FreeLocationsModal } from 'src/components/free-locations-modal'
import { InsightPaywall } from 'src/components/insights/types'
import { Colors, Shapes } from 'src/components/theme'
import { CreateSubscription } from 'src/views/subscriptions/create'
import { UpdateSubscriptionModal } from 'src/views/subscriptions/update'

import * as authAtoms from 'src/atoms/auth'
import * as paymentsAtoms from 'src/atoms/payments'

const CreateAccount = dynamic(() => import('src/views/auth/index'), { ssr: false })

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[4]}px;
  background-color: ${Colors.bgDark};
  padding: ${Shapes.spacing[6]}px;
  border-radius: ${Shapes.borderRadius}px;
`
const ButtonGroup = styled.div`
  display: flex;
  gap: ${Shapes.spacing[4]}px;
  button {
    height: 40px;
    width: 220px;
  }
`

type InsightLockedActionsProps = {
  paywall?: InsightPaywall
  hasFreeLocations?: boolean
  style?: React.CSSProperties
}
export const InsightLockedActions = (props: InsightLockedActionsProps) => {
  const { paywall, hasFreeLocations = true, style } = props
  const [openFreeLocations, setOpenFreeLocations] = useState(false)
  const setOpenAccountCreate = useSetRecoilState(authAtoms.modalOpen)
  const setSubscribeModalOpen = useSetRecoilState(paymentsAtoms.subcribeModalOpen)
  const subscriptionType = useRecoilValue(paymentsAtoms.subscriptionType)

  const onOpenFreeLocation = () => setOpenFreeLocations(true)
  const onCloseFreeLocation = () => setOpenFreeLocations(false)

  const onOpenUpgrade = () => setSubscribeModalOpen(true)

  const onOpenCreateAccount = () => setOpenAccountCreate(true)

  const onClickUpgrade = () => {
    if (!subscriptionType) {
      onOpenCreateAccount()
      return
    }
    onOpenUpgrade()
  }

  if (!paywall) {
    return null
  }
  return (
    <>
      <Wrapper style={style}>
        <Typography variant="title1" color={Colors.textBlack}>
          {paywall.title}
        </Typography>
        <Typography variant="textmdm" color={Colors.textDark}>
          {paywall.description}
        </Typography>
        <ButtonGroup>
          <ButtonWithIcon inverted onClick={onClickUpgrade}>
            Upgrade Plan
          </ButtonWithIcon>
          {hasFreeLocations && <ButtonWithIcon onClick={onOpenFreeLocation}>View in a Sample Location</ButtonWithIcon>}
        </ButtonGroup>
      </Wrapper>
      {subscriptionType === 'new' ? (
        <CreateSubscription />
      ) : subscriptionType === 'existing' ? (
        <UpdateSubscriptionModal />
      ) : (
        <CreateAccount />
      )}
      <FreeLocationsModal open={openFreeLocations} onClose={onCloseFreeLocation} />
    </>
  )
}
